<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="invoices"
    sort-by="providerName"
    group-by="errorMessage"
    item-key="sessionInvoiceId"
    show-select
    fixed-header
    hide-default-footer
    disable-pagination
    dense
    :loading="loading"
  >
    <template v-slot:[`top`]>
      <v-toolbar flat>
        <remove-invoice-modal
          :removeOnly="true"
          :selected="selected"
          @syncInvoices="syncInvoices"
        ></remove-invoice-modal>
        <remove-invoice-modal
          :removeOnly="false"
          :selected="selected"
          @syncInvoices="syncInvoices"
        ></remove-invoice-modal>
      </v-toolbar>
    </template>
    <template v-slot:[`group.header`]="{ group, headers, toggle, isOpen }">
      <td :colspan="headers.length">
        <v-btn @click="toggle" x-small icon :ref="group">
          <v-icon v-if="isOpen">mdi-minus</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
        <span class="mx-5 font-weight-bold" style="font-size: 14px">{{
          group
        }}</span>
      </td>
    </template>
  </v-data-table>
</template>
<script>
import RemoveInvoiceModal from "./remove-invoice-modal.vue";
export default {
  props: ["errorInvoices"],
  components: {
    RemoveInvoiceModal,
  },
  data() {
    return {
      headers: [
        { text: "Client", value: "clientName" },
        { text: "Client OSIS", value: "clientOsis" },
        { text: "Provider", value: "providerName" },
        { text: "Date of Service", value: "formattedDos" },
        { text: "Time", value: "startTime", sortable: false },
        { text: "Duration", value: "formattedDuration", sortable: false },
        { text: "Billed Amount", value: "formattedBilledAmount" },
        { text: "Error Message", value: "errorMessage" },
      ],
      selected: [],
      loading: false,
      invoices: this.errorInvoices,
    };
  },
  methods: {
    syncInvoices(removedInvoiceIds) {
      this.invoices = this.invoices.filter(
        (item) => !removedInvoiceIds.includes(item.sessionInvoiceId)
      );
      this.selected = this.selected.filter(
        (item) => !removedInvoiceIds.includes(item.sessionInvoiceId)
      );
    },
  },
};
</script>
